import React from 'react'
import img1 from "../img/abaut-img1.png"
import img2 from "../img/about-img2.png"
const About = () => {
  return (
    <main className='main'>
      <img src={img1} alt="" />
      <div className='container about-container'>
        <p className='about-text'> 
          At The Babypink Republic, every piece is crafted with care, passion, and purpose.
          We believe that clothing should feel as beautiful as it looks
           — soft on the skin, gentle in design, and made to bring comfort into your everyday life.

          Our items are created using high-quality, carefully selected fabrics that provide breathability, durability, and a perfect fit.
          Each design blends elegance, minimalism, and femininity, allowing you to feel confident, cozy, and effortlessly stylish.

          We focus on details — from stitching and texture to color harmony and silhouette — because true beauty is found in precision.
          Whether for home, rest, or self-expression, our pieces are made to make you feel special.

          Welcome to a world where softness meets style.            Welcome to The Babypink Republic.
        </p>
      </div>
      <img className='about-img2' src={img2} alt="" />
    </main>
  )
}

export default About